import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private apiUrl = 'http://localhost:3000/api/email'; // Adjust to your server URL

  constructor(private http: HttpClient) { }

  sendEmail(emailData: { to: string, subject: string, text?: string, html?: string, logoBase64?: string, pdfPath?: string, attachments?: { filename: string, path?: string, content?: string, encoding?: string }[] }): Observable<any> {
    console.warn('Sending email')
    return this.http.post(`${this.apiUrl}/send-pdf`, emailData);
  }
}
